import QuickActionsConnected from './QuickActionsConnected'
export default QuickActionsConnected
